module.exports = __webpack_public_path__ + "images/柏纳s长图_01.jpg?v=a03ce789";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan2/柏纳s长图_01.jpg
 ** module id = 156
 ** module chunks = 1 2
 **/